var map = {
	"./Contact lens - Cori Qu.png": 5360,
	"./code.png": 1571,
	"./correctoverrides.png": 909,
	"./correctupdate.png": 2815,
	"./correctvariant.png": 9193,
	"./cover.png": 735,
	"./cover3.png": 2436,
	"./fdlogo.svg": 9365,
	"./hero.png": 7236,
	"./newreplacement.gif": 613,
	"./oldreplacement.gif": 8102,
	"./playgroundfile.png": 2481,
	"./plugin.gif": 7982,
	"./workshop.png": 3067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7298;